var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        "primary-action": _vm.primaryAction,
        "secondary-actions": _vm.secondariesActions,
        title: _vm.$t.__("common.actions.buy_credits"),
        visible: _vm.visible,
        size: "small"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        closed: _vm.onClose
      }
    },
    [
      _vm.loading
        ? _c(
            "template",
            { slot: "default" },
            [
              _c("CompassLoader", {
                staticClass: "preloader-container__loader"
              })
            ],
            1
          )
        : _c(
            "template",
            { slot: "default" },
            [
              _c(
                "p",
                {
                  staticClass:
                    "typographies-paragraph-medium-regular chargebee-quota-dialog__subtitle"
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Définissez le nombre de packs de crédits que vous souhaitez acheter en fonction de vos besoins."
                        )
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.dialogCredits, function(credit) {
                return _c(
                  "div",
                  {
                    key: credit.id,
                    staticClass: "chargebee-quota-dialog__credit"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "chargebee-quota-dialog__credit-title" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chargebee-quota-dialog__credit-title-name"
                          },
                          [
                            _c("CompassIcon", { attrs: { icon: credit.icon } }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-bold"
                              },
                              [_vm._v(" " + _vm._s(credit.title) + " ")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "typographies-paragraph-small-semibold",
                            class: {
                              "chargebee-quota-dialog__credit-title-remaining--none":
                                credit.remaining === 0
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "%s restant",
                                    "%s restants",
                                    credit.remaining,
                                    credit.remaining
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chargebee-quota-dialog__credit-content" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chargebee-quota-dialog__credit-content-input"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "number-input-quota-container" },
                              [
                                _c("CompassNumberInput", {
                                  attrs: {
                                    disabled: !credit.enabled,
                                    "model-value": credit.quantity,
                                    step: 1,
                                    min: 0
                                  },
                                  on: {
                                    change: function(quantity) {
                                      return _vm.onQuantityChanged(
                                        credit,
                                        quantity
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                !credit.enabled
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "feature-badge-wrapper",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClickInputContainer(
                                              credit
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("CompassFeatureBadge", {
                                          attrs: {
                                            size: "small",
                                            variant: "upsell",
                                            isInteractive: ""
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(credit.description) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "typographies-paragraph-medium-regular"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(credit.price * credit.quantity) +
                                " €\n                "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "chargebee-quota-dialog__total" }, [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-large-bold" },
                  [_vm._v(_vm._s(_vm.$l10n.__("Total HT")))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-large-bold" },
                  [_vm._v(_vm._s(_vm.total) + " €")]
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "typographies-paragraph-small-regular chargebee-quota-dialog__information-text"
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "En cliquant sur continuer, vous allez être redirigé vers notre partenaire Chargebee pour procéder au paiement. Dès sa validation, vos crédits sont rapidement ajoutés à votre compte."
                        )
                      ) +
                      "\n        "
                  )
                ]
              )
            ],
            2
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }